import { render, staticRenderFns } from "./AdminCashier.vue?vue&type=template&id=371c5729"
import script from "./AdminCashier.vue?vue&type=script&lang=js"
export * from "./AdminCashier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports